/**
 * Events related to version history tracking.
 *
 * @enum VersionHistory
 * @package App/Event
 * @project ChalkySticks App
 */
export enum VersionHistory {
	FirstLaunch = 'versionHistory:firstLaunch',
	Initialized = 'versionHistory:initialized',
	NewVersionDetected = 'versionHistory:newVersionDetected',
}
